import * as yup from 'yup'
import { reactLocalStorage } from 'reactjs-localstorage'
import emptyStringToNull from 'utils/emptyStringToNull'
import afterDate from 'utils/afterDate.validation'

yup.addMethod(yup.string, 'exists', function (message) {
  return this.test({
    name: 'exists',
    exclusive: true,
    message,
    test: async function (value, schema) {
      const token = reactLocalStorage.get('token')
      const { id } = schema.parent
      const requestOptions = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authtoken: token,
        },
        body: JSON.stringify({ programName: value, id }),
      }
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}scholarships-stage/exists`,
        requestOptions
      )
      const json = await response.json()
      return !json.exists
    },
  })
})

const minDate = new Date(2000, 0, 1)
const maxDate = new Date(2100, 11, 31)

const dateBetween = (minDate, maxDate, message) => {
  return yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(minDate, message || `Date must be after ${minDate.toDateString()}`)
    .max(maxDate, message || `Date must be before ${maxDate.toDateString()}`)
}

export const ProgramSchema = yup.object().shape({
  id: yup.string(),
  programName: yup
    .string()
    .trim()
    .required()
    .max(100)
    .exists('Program already exists'),
  scholarshipMaximumAward: yup
    .number()
    .positive()
    .moreThan(0)
    .transform(emptyStringToNull)
    .nullable(),
  scholarshipMinimumAward: yup
    .number()
    .positive()
    .moreThan(0)
    .transform(emptyStringToNull)
    .nullable()
    .when('scholarshipMaximumAward', (st, schema) => {
      return st
        ? yup
            .number()
            .moreThan(0)
            .transform(emptyStringToNull)
            .nullable()
            .max(st)
        : schema
    }),
  programSelfDescription: yup.string().max(4000),
  numberOfScholarshipsAwarded: yup
    .number()
    .positive()
    .moreThan(0)
    .integer()
    .transform(emptyStringToNull)
    .nullable(),
  academicEligibilityMinGPA: yup
    .number()
    .positive()
    .min(1)
    .max(5)
    .transform(emptyStringToNull)
    .nullable(),
  academicEligibilityMinActComposite: yup
    .number()
    .positive()
    .min(1)
    .max(36)
    .transform(emptyStringToNull)
    .nullable(),
  academicEligibilityMinOverallSat: yup
    .number()
    .positive()
    .min(400)
    .max(1600)
    .transform(emptyStringToNull)
    .nullable(),
  financialEligibilityMaximumAgi: yup
    .number()
    .positive()
    .min(1)
    .transform(emptyStringToNull)
    .nullable(),
  financialEligibilityMaximumEfc: yup
    .number()
    .positive()
    .min(1)
    .transform(emptyStringToNull)
    .nullable(),
  academicEligibilityMinClassRank: yup
    .number()
    .positive()
    .min(1)
    .max(100)
    .transform(emptyStringToNull)
    .nullable(),
  programURL: yup.string().url(),
  applicationURL: yup.string().url(),
  openDate: dateBetween(
    minDate,
    maxDate,
    'Date must be between January 1, 2000 and December 31, 2100'
  ),
  closeDate: dateBetween(
    minDate,
    maxDate,
    'Date must be between January 1, 2000 and December 31, 2100'
  ).when('openDate', afterDate('Close Date must be later than the Open Date')),
  announcementDate: dateBetween(
    minDate,
    maxDate,
    'Date must be between January 1, 2000 and December 31, 2100'
  )
    .when('openDate', afterDate(`Date must be later than Open Date`))
    .when('closeDate', afterDate(`Date must be later than Close Date`)),
})
